import React from 'react';
import classNames from 'classnames';

import './CustomError.scss';

interface CustomErrorProps {
  children: string | React.ReactElement;
  type?: 'error' | 'note' | 'success';
}

// TODO: Rename this component into something more abstract like - CustomMessage
export const CustomError: React.FC<CustomErrorProps> = ({ children, type = 'error' }) => {

  return (
    <div styleName="custom-error">
      <span styleName={classNames('custom-error__text', {
        success: type === 'success',
        error: type === 'error',
        note: type === 'note'
      })}>{children}</span>
    </div>
  );
};

export default CustomError;
